import { Service } from '@angular/core';
import { RxStomp } from '@stomp/rx-stomp';
import { rxStompServiceFactory } from './rx-stomp-service-factory';

@Service({
  factory: () => rxStompServiceFactory()
})
export class RxStompService extends RxStomp {
  constructor() {
    super();
  }
}